module.exports = __webpack_public_path__ + "assets/img/eternia-solar-services-logo-small.716b1a7c.webp";